import React from 'react';
import styled from 'styled-components';
import { ILdsContactUsData } from '../lds-contact-us.data';
//@ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';

interface SelectProps {
    ContactData: ILdsContactUsData;
    handleSelect: any;
    currentCountry: any;
    sortedList?: any;
    resources: any;
}

const CountrySelector = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 81.5px;
    align-items: flex-end;

    @media (max-width: 750px) {
        flex-direction: column;
        align-items: center;
    }
`;

const SelectWrapper = styled.div`
    width: 28%;
    margin-right: 10px;

    @media (max-width: 750px) {
        margin-right: 0xp;
        width: 50%;
        margin-bottom: 16px;
    }

    @media (max-width: 478px) {
        width: 75%;
    }
`;

// const StyledSelect = styled.select`
//     width: 100%;
//     height: 40px;
// `;

// const Label = styled.label`
//     font-size: 14px;
//     font-weight: 400;
//     line-height: 19px;
//     color: #53575b;
// `;

export const ContactCountrySelect: React.FC<SelectProps> = ({ ContactData, handleSelect, currentCountry, sortedList, resources }) => {
    const countriesList = ContactData.countries?.result;

    return (
        <CountrySelector>
            <SelectWrapper>
                <div>
                    <label className='ContactLabel' htmlFor=''>
                        {resources.tableHeaderCountry}
                    </label>
                </div>
                <select
                    className='StyledSelect'
                    name='country'
                    id=''
                    onChange={(e: any) => handleSelect(e.target.value)}
                    //@ts-ignore
                    value={currentCountry ? JSON.stringify(currentCountry.Id) : ''}
                >
                    <option value='' disabled selected>
                        {resources.defaultSelectValue}
                    </option>
                    {sortedList
                        ? sortedList?.map((country: any) => {
                              return (
                                  <option value={country.Id} key={country.Id}>
                                      {country.CountryName}
                                  </option>
                              );
                          })
                        : countriesList?.map((country: any) => {
                              return (
                                  <option value={country.Id} key={country.Id}>
                                      {country.CountryName}
                                  </option>
                              );
                          })}
                </select>
            </SelectWrapper>
        </CountrySelector>
    );
};
